export const aciFullBoard = {
    iconName: 'full-board',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: {
            attr: {
                d: 'M5.143 9.714V20M18.855 14.286h1.716a.571.571 0 00.572-.57c.006-2.919.021-6.444-1.188-9.363a.571.571 0 00-1.1.219V20M4 4v4.572a1.143 1.143 0 002.286 0V4M16 9.168a5.465 5.465 0 00-7.425-.533M8 17.118a5.47 5.47 0 008 0',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
